import http from "helpers/http.js";
import Analytics from "analytics";

const API_URL = process.env.REACT_APP_API_URL;

const register = (email, password, country) => {
    var data = JSON.stringify({
        "Email": email,
        "Password": password,
        "Country": country,
    });

    var config = {
        method: 'post',
        url: API_URL + 'api/Authenticate/register-no-voucher',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return http(config)
        .then(function (response) {
            console.log(JSON.stringify(response.data));
            const status = response.status;

            Analytics.signUp();
            return response;
        })
        .catch(function (error) {
            console.log(error);
            return error.response.data;
        });
};

/**
 * Logs in a user using email/password or an external provider.
 *
 * @param {Object} req - The login request object.
 * @param {string} [req.provider] - The external provider name (e.g., "google"). If not provided, email/password login is used.
 * @param {string} [req.email] - The user's email address (required for email/password login).
 * @param {string} [req.password] - The user's password (required for email/password login).
 * @param {string} [req.idToken] - The external provider ID token (required for external login).
 * @param {string} [req.QRSessionID] - Optional QR session ID for device login.
 * @param {string} [req.country] - Optional country code.
 * @returns {Promise<Object>} Resolves with user data on success, or error data on failure.
 */
const login = (req) => {
    var data;
    var configLogin;
    if (!req.provider || req.provider === "none") {
        data = JSON.stringify({
            Email: req.email,
            Password: req.password,
            QRSessionID: req.QRSessionID,
            Country: req.country,
        });

        configLogin = {
            method: 'post',
            url: API_URL + 'api/Authenticate/login',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
    } else {
        data = JSON.stringify({
            provider: req.provider,
            IdToken: req.idToken,
            QRSessionID: req.QRSessionID,
            Country: req.country,
        });

        configLogin = {
            method: 'post',
            url: API_URL + 'api/Authenticate/external-login',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
    }

    return http(configLogin)
        .then(function (response) {
            console.log(response)
            if (response.data.token) {
                localStorage.setItem("user", JSON.stringify(response.data));
            }
            //localStorage.setItem("games", JSON.stringify(response.data.games));
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
};

const checkAccountExists = (email) => {
    var data = JSON.stringify({
        "Username": email
    })

    var request = {
        method: 'post',
        url: API_URL + 'api/Authenticate/check-account-exists',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return http(request)
        .then(function (response) {
            return response.data;
        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
}

/// <summary>
/// Requests a QR session for device login.
/// </summary>
/// <param name="oldSessionID">The old session ID to overwrite (optional).</param>
/// <param name="ttl">The time-to-live (TTL) for the session in seconds.</param>
/// <returns>A promise that resolves with the session data.</returns>
/// <remarks>
const requestQRSession = (oldSessionID, ttl) => {
    var data = JSON.stringify({
        "OverwriteSessionID": oldSessionID,
        "ttl": ttl
    });

    var request = {
        method: 'post',
        url: API_URL + 'api/Authenticate/request-qr-session',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return http(request)
        .then(function (response) {
            if (response.data?.sessionID) {
                localStorage.setItem("QRSessionData", JSON.stringify(response.data));
            }
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
}

const getQRSession = (QRSessionID) => {
    var data = JSON.stringify({
        "QRSessionID": QRSessionID,
    });

    var request = {
        method: 'post',
        url: API_URL + 'api/Authenticate/get-qr-session',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return http(request)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return { ...error.response.data, error };
        });
}

const autoLoginQRSession = (QRSessionID, UserID) => {
    var data = JSON.stringify({
        "QRSessionID": QRSessionID,
        "UserID": UserID,
    });

    var request = {
        method: 'post',
        url: API_URL + 'api/Authenticate/auto-login-qr-session',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return http(request)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return { ...error.response.data, error };
        });
}


const getLatestRoomID = (QRSessionID) => {
    var data = JSON.stringify({
        "QRSessionID": QRSessionID,
    });

    var request = {
        method: 'post',
        url: API_URL + 'api/Authenticate/get-roku-room-id',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return http(request)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return { ...error.response.data, error };
        });
}

const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("games");
};

const getGames = (email) => {
    var configGetGames = {
        method: 'post',
        url: API_URL + 'api/Authenticate/GetGames',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            email,
        }
    };

    return http(configGetGames)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
};

const redeemCode = (code) => {
    var configGetGames = {
        method: 'post',
        url: API_URL + 'api/Authenticate/ApplyVoucherCode',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            voucherCode: code,
        }
    };

    return http(configGetGames)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
}

const checkCode = (code) => {
    var configGetGames = {
        method: 'post',
        url: API_URL + 'api/Authenticate/CheckVoucherCode',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            voucherCode: code,
        }
    };

    return http(configGetGames)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
}

const redeemMultipleCodes = (codes) => {
    var configGetGames = {
        method: 'post',
        url: API_URL + 'api/Authenticate/ApplyMultipleVoucherCodes',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            voucherCodes: codes,
        }
    };

    return http(configGetGames)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
}

const sendGiftVoucher = (codes) => {
    var configSendGiftVoucher = {
        method: 'post',
        url: API_URL + 'api/Authenticate/SendGiftVoucher',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            VoucherCodes: codes,
        }
    };

    return http(configSendGiftVoucher)
        .then(function (response) {
            return response.data;

        }).catch(function (error) {
            console.log(error);
            return error.response.data;
        });
}

const forgotPassword = (email) => {
    var data = JSON.stringify({
        "Email": email,
    });

    var configForgotPassword = {
        method: 'post',
        url: API_URL + 'api/Authenticate/forgot-password',
        headers: {
            'Content-Type': 'application/json'
        },
        data,
    };

    return http(configForgotPassword)
        .then((response) => {
            return response.data;
        }).catch((error) => {
            console.log(error);
            return error.response.data;
        });
}

const resetPassword = (email, token, password, confirmPassword) => {
    var data = JSON.stringify({
        "Email": email,
        "Token": token,
        "Password": password,
        "ConfirmPassword": confirmPassword
    });

    var configReset = {
        method: 'post',
        url: API_URL + 'api/Authenticate/reset-password',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return http(configReset)
        .then((response) => {
            return response.data;

        }).catch((error) => {
            console.log(error);
            return error.response.data;
        });
}


export default {
    register,
    login,
    logout,
    getGames,
    redeemCode,
    redeemMultipleCodes,
    forgotPassword,
    resetPassword,
    checkCode,
    requestQRSession,
    getQRSession,
    autoLoginQRSession,
    getLatestRoomID,
    sendGiftVoucher,
    checkAccountExists
};
